import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import type { TicketDistributionData } from './types';

export const getTableColumnsWithoutActionColumn = () => {
  const columns: ColumnsType<TicketDistributionData> = [
    {
      title: '發放票券',
      dataIndex: 'ticketName',
    },
    {
      title: '票券發放日',
      dataIndex: 'issueDate',
      render: (issueDate) => {
        return dayjs(issueDate).format('YYYY/MM/DD');
      },
    },
    {
      title: '票券使用起始日',
      dataIndex: 'startDate',
      render: (startDate) => {
        return dayjs(startDate).format('YYYY/MM/DD');
      },
    },
    {
      title: '票券使用結束日',
      dataIndex: 'endDate',
      render: (endDate) => {
        return dayjs(endDate).format('YYYY/MM/DD');
      },
    },
    {
      title: '分發對象',
      dataIndex: 'recipients',
      width: 400,
      render: (_, { recipients: { plans, members } }) => {
        const plansText = plans.map((plan) => plan.label).join('、');
        const membersText = members.map((member) => member.label).join('、');
        return `${plansText}、${membersText}`;
      },
    },
    {
      title: '發放券數',
      dataIndex: 'amount',
    },
  ];

  return columns;
};
